import { IconButton, Stack, Tooltip, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { navigate } from "lib/routes/navigate"
import { If } from "lib/@components/switch"
import { buildFlaggedTaskReason, getRegimeGroupId } from "./data-quality-detail-utils"

export function DataQualityTaskRow({ item, alertId, regimeId, currencySymbol }) {
    const groupId = getRegimeGroupId(regimeId)
    const meta = formatMeta()
    return (
        <Stack
            direction="row"
            spacing={1}
            alignItems="flex-start"
            justifyContent="space-between"
            sx={{ py: 1.5 }}
            data-cy={`data-quality-task-row-${alertId}`}
        >
            <Stack spacing={0.25} sx={{ minWidth: 0 }}>
                <Typography variant="subtitle2">{item.title || "Untitled task"}</Typography>
                <Typography variant="caption" color="text.secondary">
                    {formatSchedule()}
                </Typography>
                <If value={!!meta}>
                    <Typography variant="caption" color="text.secondary">
                        {meta}
                    </Typography>
                </If>
                <Typography variant="caption">{buildFlaggedTaskReason(alertId, item, currencySymbol)}</Typography>
            </Stack>
            <If value={!!groupId}>
                <Tooltip title="Open regime">
                    <IconButton
                        size="small"
                        data-cy={`data-quality-task-link-${alertId}`}
                        aria-label="Open the regime containing this task"
                        onClick={handleNavigate}
                    >
                        <Iconify icon="mdi:open-in-new" />
                    </IconButton>
                </Tooltip>
            </If>
        </Stack>
    )

    function formatSchedule() {
        if (item.scheduleCode) return `${item.scheduleCode} · ${item.scheduleTitle}`
        return item.scheduleTitle || "-"
    }

    function formatMeta() {
        const parts = []
        if (item.skillName) parts.push(item.skillName)
        if (item.assetCount) parts.push(`${item.assetCount} ${item.assetCount === 1 ? "asset" : "assets"}`)
        return parts.join(" · ")
    }

    function handleNavigate() {
        // v1 links to the regime root: the cost engine only knows the schedule record id,
        // and regime tree item ids are instance-based so a schedule-level link is not
        // derivable from the persisted cost result.
        navigate(`/app/schedules?id=${groupId}`)
    }
}
